export default __webpack_public_path__ + "static/media/Production.efc5c18d.png";